import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=28dc3cea&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=28dc3cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc3cea",
  null
  
)

export default component.exports